import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable, combineLatest, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SubSink } from 'subsink';
import { ExdrLanguageService } from '../../languages/services/exdr-language.service';
import { Addon } from '../../shared/models/addon.model';
import { AuthService, AuthType } from '../../shared/services/auth.service';
import { GroupLabelService } from '../../shared/services/group-label.service';
import { MetaService } from '../../shared/services/meta.service';
import { SharedService } from '../../shared/shared.service';

@Component({
  selector: 'xcdrs-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent implements OnInit {
  iframeAddon: Addon;
  iframeSafeUrl: any
  subs: SubSink = new SubSink();
  constructor(private sanitizer: DomSanitizer,
    private sharedService: SharedService,
    private authService: AuthService,
    private route: ActivatedRoute,
    private metaService: MetaService,
    private langService: ExdrLanguageService,
    private groupLabelService: GroupLabelService) { }

  ngOnInit(): void {
    const parentParams = this.route.parent?.params ?? of({});
    this.subs.sink = combineLatest([this.route.params, parentParams]).pipe(
      switchMap(([params, parent]) => {
        const routeParams = { ...parent, ...params };
        return this.authService.getAddonsAuth(this.authService.idenediGroupId).pipe(
          switchMap(addons => {
            const customAddonsTypes = [AuthType.CustomTab, AuthType.Footer];
            const customAddons = addons.filter(ad => customAddonsTypes.includes(ad.Type as AuthType));
            this.iframeAddon = this.findAddonByParams(customAddons, routeParams);
            return this.getUrl();
          })
        );
      })
    ).subscribe(url => {
      const sanitizedUrl = url ? this.sanitizer.sanitize(SecurityContext.URL, url) : null;
      this.iframeSafeUrl = sanitizedUrl
        ? this.sanitizer.bypassSecurityTrustResourceUrl(sanitizedUrl)
        : null;
    });
  }

  getUrl(): Observable<string> {
    const url = this.iframeAddon?.PublicProperties?.iFrameURL;
    if (!url) {
      return of('');
    }
    const currentLocale = this.langService.currentLanguage?.locale;
    const tabKey = this.iframeAddon.PublicProperties?.customTabId || this.iframeAddon.InstanceId;
    if (!currentLocale || !tabKey) {
      return of(this.fixUrl(url));
    }
    return this.groupLabelService.getTabLocaleData(tabKey, currentLocale).pipe(map(langData => {
      const localizedUrl = langData?.isEnable == '1' ? langData?.url?.trim() : '';
      return this.fixUrl(localizedUrl || url);
    }));
  }
  findAddonByParams(addons: Addon[], params: any): Addon {
    return addons.find(add => {
      if (params['slug']) {
        return add.PublicProperties?.urlName == params['slug'];
      }
      else {
        if (add.Type == AuthType.Footer) {
          return add.PublicProperties?.refTab == params['id'] || add.InstanceId == params['id']
        }
        return add.InstanceId == params['id']
      }
    })
  }

  fixUrl(url: string): string {
    if (!url.toLowerCase().startsWith('http')) {
      url = 'https://' + url;
    }
    return url;
  }
  ngOnDestroy(): void {
    this.metaService.removeCanonicalURL();
    this.subs.unsubscribe();
  }
}
